import { atom } from 'jotai';

import { userInstanceAtom } from './userDetails';

import { getPerformanceTier } from '@/utils/performanceTier';

/**
 * The company's Performance tier, read from the access keys the host sends with the reader.
 *
 * Derived rather than written: both entry points (`./App` and `./performance-profile`) already write
 * the user, so neither has to remember a second write, and a host that re-sends the user after a
 * plan change moves the tier with it.
 */
export const performanceTierAtom = atom((get) => getPerformanceTier(get(userInstanceAtom)));
